export default __webpack_public_path__ + "static/media/failed.bbbbeb05.svg";